import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-38">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-39">
        <img src="https://cdn.magicpatterns.com/uploads/jDnDM2SkXUvPXmFXVwb7kD/Imagen_referencia_5.png" alt="Bosque mágico y abundante" className="w-full h-full object-cover object-center" data-id="element-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDFBF7]/90 via-[#FDFBF7]/80 to-[#FDFBF7] backdrop-blur-[2px]" data-id="element-41"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
          <span className="inline-block py-1 px-3 rounded-full border border-[#C5A059]/30 bg-[#C5A059]/10 text-[#A8823A] text-sm font-medium tracking-wider uppercase mb-6" data-id="element-44">
            Siente la paz de una vida en abundancia
          </span>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-stone-900 mb-6 leading-tight" data-id="element-45">
            El Código Invisible <br className="hidden md:block" data-id="element-46" />
            <span className="gold-text-gradient italic font-normal" data-id="element-47">
              del Dinero
            </span>
          </h1>

          <h2 className="text-xl md:text-2xl text-stone-700 font-serif mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-48">
            Deja de perseguir el dinero y permite que la abundancia te
            encuentre. El manual de reprogramación vibracional diseñado para la
            mujer consciente.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white/60 backdrop-blur-md border border-white/40 p-8 rounded-2xl shadow-xl max-w-3xl mx-auto mb-8 text-left" data-id="element-49">
          <p className="text-stone-600 text-lg leading-relaxed" data-id="element-50">
            Nos enseñaron que el dinero se gana con "sudor y lágrimas", pero la
            verdad es más profunda:{' '}
            <strong className="text-stone-800 font-semibold" data-id="element-51">
              El dinero no se gana, se sintoniza.
            </strong>
            <br data-id="element-52" />
            <br data-id="element-53" />
            Si estás cansada de ser la "cazadora" que corre agotada por un
            bosque de cuentas y estrés, es hora de detenerte. Es hora de sanar
            tu tierra y convertirte en el jardín donde la prosperidad aterriza
            por diseño.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex justify-center mb-12" data-id="element-54">
          <a href="#oferta" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_30px_rgba(197,160,89,0.4)] transition-all hover:shadow-[0_0_50px_rgba(197,160,89,0.6)] hover:scale-105" data-id="element-55">
            <div className="absolute inset-0 gold-gradient" data-id="element-56"></div>
            <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-57"></div>
            <span className="relative flex items-center gap-2" data-id="element-58">
              SÍ, QUIERO VER LA OFERTA
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-59" />
            </span>
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="flex flex-col items-center justify-center gap-3" data-id="element-60">
          <div className="flex gap-1" data-id="element-61">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C5A059] text-[#C5A059]" data-id="element-62" />)}
          </div>
          <p className="text-stone-600 font-medium text-sm md:text-base max-w-md" data-id="element-63">
            Más de 4,500 mujeres en toda habla hispana han transformado su
            "termostato financiero" con este método.
          </p>
        </motion.div>
      </div>
    </section>;
}